import type { AccountCreateInput } from './schemas';

import { FormField } from '@/components/form-field';

export const AccountFormFields = () => (
  <>
    <FormField<AccountCreateInput> name="steamLogin" label="Steam login" placeholder="johndoe" />
    <FormField<AccountCreateInput> name="steamId64" label="Steam ID64" placeholder="7656119…" />
    <FormField<AccountCreateInput>
      name="password"
      label="Пароль"
      type="password"
      placeholder="••••••••"
    />
    <FormField<AccountCreateInput>
      name="sharedSecret"
      label="Shared secret"
      placeholder="base64…"
    />
    <FormField<AccountCreateInput>
      name="identitySecret"
      label="Identity secret"
      placeholder="base64…"
    />
    <FormField<AccountCreateInput>
      name="revocationCode"
      label="Revocation code (опционально)"
      placeholder="R12345"
    />
    <FormField<AccountCreateInput>
      name="email"
      label="Email (опционально)"
      placeholder="acc@gmail.com"
    />
    <FormField<AccountCreateInput>
      name="emailPassword"
      label="Email password (опционально)"
      type="password"
      placeholder="••••••••"
    />
  </>
);
